import { render, staticRenderFns } from "./OrderTypeSelector.vue?vue&type=template&id=fe8a6194&scoped=true"
import script from "./OrderTypeSelector.vue?vue&type=script&lang=js"
export * from "./OrderTypeSelector.vue?vue&type=script&lang=js"
import style0 from "./OrderTypeSelector.vue?vue&type=style&index=0&id=fe8a6194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8a6194",
  null
  
)

export default component.exports